export default [
    {
        path: "/admin/position-hierarchies",
        name: "position-hierarchy",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/position-hierarchy")
    }
];
